import { nextTick, ref } from 'vue';

const visible = ref(false);
const profile_type = ref(null);
const profile_id = ref(null);
const profile_record = ref(null);
let on_deleted_callback = null;

function openProfile(profile, { on_deleted } = {}) {
  if (!profile) return;
  profile_type.value = profile.type;
  profile_id.value = profile.id;
  profile_record.value = profile;
  on_deleted_callback = typeof on_deleted === 'function' ? on_deleted : null;
  visible.value = true;
}

function closeProfile() {
  visible.value = false;
  on_deleted_callback = null;
  nextTick(() => {
    if (!visible.value) {
      profile_type.value = null;
      profile_id.value = null;
      profile_record.value = null;
    }
  });
}

function handleDeleted(profile) {
  if (on_deleted_callback) on_deleted_callback(profile);
  closeProfile();
}

export default function useProfileDrawer() {
  return {
    visible,
    profile_type,
    profile_id,
    profile_record,
    openProfile,
    closeProfile,
    handleDeleted,
  };
}
